import { render, staticRenderFns } from "./DropsmartCenterSideBar.vue?vue&type=template&id=4473dfd3&scoped=true&"
import script from "./DropsmartCenterSideBar.vue?vue&type=script&lang=js&"
export * from "./DropsmartCenterSideBar.vue?vue&type=script&lang=js&"
import style0 from "./DropsmartCenterSideBar.vue?vue&type=style&index=0&id=4473dfd3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4473dfd3",
  null
  
)


    import installComponents from "!/Users/leandrosehnembortolotto/Development/Dropsmart/dropsmith-frontend-v2/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BNavbarBrand, BNavItem, BNav, BSidebar} from 'bootstrap-vue'
    installComponents(component, {BNavbarBrand, BNavItem, BNav, BSidebar})
    

export default component.exports